import {normalizeUrl} from 'ceres/app/helper/url';

export function jQueryGet(url) {

    let config = {};

    config.method      = 'GET';
    config.dataType    = 'html';
    config.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

    const csrfToken = (document.getElementById('csrf-token') || {}).value;

    if(csrfToken) {
        config.headers = {'X-CSRF-TOKEN': csrfToken};
    }

    return $.ajax(normalizeUrl(url), config);
}
